import React from 'react';
import './footer.css'
const Footer = () => {
    return (
        <footer className="footer text-white py-4 text-center">
            <div className=" container mx-auto">
                <p style={{ color: "black" }}>&copy; 2023 Pushpender. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
